import PropTypes from "prop-types";
import React from "react";
import {
  CollapseWrap,
  PillButtonSelect,
  Title,
  DisplayFlexAlign,
  Percentage,
  UnderlinelinkRemove,
  Check,
  ContentWrap,
  AccordionStatus,
  AccordionStatusText
} from "./styles";
import AccordionContent from "../AccordionContent/AccordionContent";
import { connect } from "react-redux";
import completeIcon from '../../../../../../assets/icons/confirmation-tick.svg';
import {
  removeValues,
  showRemainingPercentage,
  saveOptionData,
  selectSuccessionPlan
} from "../../../../actions";
import { initiateTracking, recordError } from '../../../../../../utils/commonUtil';
import AlertBox from '../../../../../../CommonComponents/AlertBox';
import Preloader from '../../../../../../CommonComponents/Preloader/Preloader';
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";
class LegacyAccordions extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      show: false,
      displayType: "none",
      refresh: false,
      saved: "none",
      hasSelected: {}
    };
    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemoveState = this.handleRemoveState.bind(this);
  }
  removePopupContent = {
    heading: "Remove Information",
    line1: "<p>Are you sure you want to remove information?</p><p>Do you want to continue?</p>",
    continue: "continue",
    cancel: "No, take me back"
  };
  handleChange = action => {

    if (action) {
      this.setState({
        saved: action
      });
    }

    if (this.state.open) {
      this.setState({
        displayType: "none",
        open: !this.state.open
      });
      document.getElementById(this.props.id).scrollIntoView(true);
    } else {
      this.setState({
        displayType: "block",
        open: !this.state.open
      });
    }

    let changed = this.props.legacy.hasChange;
    this.props.saveOptionData(changed);
    if(this.props.legacy.selected === false) {
      this.props.selectSuccessionPlan({
        optionId: this.props.id,
        key: this.props.contentKey,
        selected: true
      });
      this.setState({
        hasSelected: {
          [this.props.contentKey]: true
        }
      })
    }
  };

  handleRefresh() {
    this.setState({ refresh: !this.state.refresh });
  }

  closeModal = () => {
    this.setState({
      show: false
    });
  };

  handleRemoveState = () => {
    this.setState({
      show: true
    });
  };

  handleSelect = () => {
    try {
      initiateTracking('edit', this.props.getTitle(), this.getSubTitle(), 'View & Edit');
      this.setState({
        displayType: "block",
        open: !this.state.open
      });
    } catch (error) {
      recordError(error);
    }
  };

  handleRemove = () => {
    initiateTracking("remove", this.props.getTitle(), this.getSubTitle(), "Remove");
    this.setState({
      show: false,
      saved: "cancelled",
      open: false,
      displayType: "none"
    });

    this.props.removeValues(this.props.contentKey);
    this.props.showRemainingPercentageFunc({
      showRemainingPercentage: true,
      key: this.props.contentKey,
      value: false
    });
    window.scrollTo(0, 0);
  };

  componentDidMount() {
    if (this.props.legacyPercentage > 0) {
      this.setState({
        saved: "saved"
      });
    }
  }
  componentWillReceiveProps(nextprops) {
    if (nextprops.legacyPercentage < 0 || nextprops.legacyPercentage === "") {
      this.setState({
        saved: "none"
      });
    }

    if (nextprops.subDesc) {
      this.findElem();
    }
  }

  findElem() {
    let sel = `#desc${this.props.id} a:last-child`;
    setTimeout(() => {
      let a = document.querySelector(sel);
      if (a) {
        let contentText = a.textContent;
        a.addEventListener("click", e => {
          this.props.viewEndowedGrantPlanPdf(contentText);
        });
      }
    });
  }

  getSubTitle = () => {
    const { legacyOptions, subTitle, id } = this.props;
    if (legacyOptions && legacyOptions[`field_type_${id}_title`]) {
      return legacyOptions[`field_type_${id}_title`];
    } else {
      return subTitle;
    }
  };

  getDesc = () => {
    const { legacyOptions, subDesc, id } = this.props;
    if (legacyOptions && legacyOptions[`field_type_${id}_description`]) {
      return legacyOptions[`field_type_${id}_description`];
    } else {
      return subDesc;
    }
  };

  getSubTitleWithLoader = () => {
    const { legacyOptions } = this.props;
    if (!legacyOptions) {
      return <Preloader styling="text-loader" />;
    } else {
      return this.getSubTitle();
    }
  };

  getDescWithLoader = () => {
    const { legacyOptions } = this.props;
    if (!legacyOptions) {
      return (
        <ContentWrap data-test="preloaderWrapper">
          <Preloader styling="text-loader" />
        </ContentWrap>
      );
    } else {
      return (
        <ContentWrap data-test="dataWrapper"
          id={`desc${this.props.id}`}
          dangerouslySetInnerHTML={{ __html: this.getDesc() }}
          textColor={this.props.id === "6" ? "#d4d4d4" : ""}
        ></ContentWrap>
      );
    }
  };

  render() {
    let w = window.innerWidth;
    let percent = this.props.legacyPercentage;
    if (this.state.saved === "cancelled") {
      percent = this.props.legacyPercentage;
    }

    const { legacyOptions } = this.props;

    return (
      <CollapseWrap data-test="collapseWrap">
        <AlertBox
          data-test="alertBox"
          field_page="Edit legacy options"
          name="Remove Info"
          show={this.state.show}
          primaryBtnEvent={this.handleRemove.bind(this)}
          secondaryBtnEvent={this.closeModal.bind(this)}
          defaultContent={this.removePopupContent}
        />

        <div>
          <DisplayFlexAlign data-test="dataContent">
            <div id={this.props.id}>
              <Title data-test="titleContent" textColor={this.props.id === "6" ? "#d4d4d4" : "#022737"}>{this.getSubTitleWithLoader()}</Title>
              {w <= 768 ? (
                <Percentage
                 data-test="percentageContent"
                  marginRight="48px"
                  textColor={
                    this.props.id === "6" ? "#00677891" : this.props.id !== "6" && percent > 0 ? "#69923a" : "#d4d4d4"
                  }
                >
                  {percent ? percent : 0}%
                </Percentage>
              ) : null}

              {this.getDescWithLoader()}

              {w > 768 ? (
                <Percentage
                 data-test="dataPercentage"
                  marginRight="48px"
                  textColor={
                    this.props.id === "6" ? "#00677891" : this.props.id !== "6" && percent > 0 ? "#69923a" : "#d4d4d4"
                  }
                >
                  {percent ? percent : 0}%
                </Percentage>
              ) : null}

              {this.props.id !== 6 ? (
                this.state.open ? null : this.props.legacyPercentage > 0 ? (
                  <div>
                    <CapsuleButton
                      text="View & Edit"
                      data-test="viewAndEditContent"
                      onClick={this.handleSelect}
                      whiteBackground
                      styles="accordion-select inline-block"
                      mobWidth="135px"
                    />
                    <UnderlinelinkRemove data-test ="removeLinkContent" onClick={this.handleRemoveState} className="inline-block">
                      Remove
                    </UnderlinelinkRemove>
                  </div>
                ) : (
                  <CapsuleButton
                    text="Select"
                    id={`Select${this.props.id}${this.props.contentKey}`}
                    onClick={event => {
                      try {
                        initiateTracking("select", this.props.getTitle(), this.getSubTitle(), "Select");
                        this.handleChange(event);
                      } catch(error) {
                        recordError(error);
                      }
                    }}
                    whiteBackground
                    styles="accordion-select"
                    mobWidth="135px"
                  />
                )
              ) : null}
            </div>
            {this.props.showRemainingPercentage === true && (
              <AccordionStatus data-test="contentAccordionStatus">
                <img src={completeIcon} alt="Complete" width="36" height="36" />
                <AccordionStatusText color="#69923a">Complete</AccordionStatusText>
              </AccordionStatus>
            )}
          </DisplayFlexAlign>
          <Check displayType={this.state.displayType}>
            <AccordionContent
              data-test="contentAccordion"
              selectedPlans={this.state.hasSelected}
              handleRefresh={this.handleRefresh}
              handleChange={this.handleChange}
              handleRemove={this.handleRemove}
              head={this.getSubTitle()}
              contentKey={this.props.contentKey}
              value={percent}
              id={`${this.props.id}${this.props.contentKey}`}
            />
          </Check>
        </div>
      </CollapseWrap>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  legacy: state.getIn(["myAccount", "legacyValues", `${ownProps.contentKey}`]),
  legacyPercentage: state.getIn([
    "myAccount",
    "legacyValues",
    `${ownProps.contentKey}`,
    "assignedPercentage"
  ]),
  showRemainingPercentage: state.getIn([
    "myAccount",
    "showRemainingPercentage",
    `showRemainingPercentage${ownProps.contentKey}`
  ])
});


LegacyAccordions.propTypes = {
  contentKey: PropTypes.string,
  getTitle: PropTypes.func,
  id: PropTypes.string,
  legacy: PropTypes.shape({
    accountId: PropTypes.number,
    assignedPercentage: PropTypes.number,
    hasChange: PropTypes.bool,
    note: PropTypes.any,
    optionId: PropTypes.number,
    optionName: PropTypes.string,
    otherSuccessionDetailsList: PropTypes.any,
    planType: PropTypes.any,
    selected: PropTypes.bool,
    successionPlanGranteeOrg: PropTypes.arrayOf(PropTypes.any),
    successionPlanId: PropTypes.number,
    successorAdvisor: PropTypes.any
  }),
    legacyOptions: PropTypes.any,
  legacyPercentage: PropTypes.number,
  removeValues: PropTypes.func,
  saveOptionData: PropTypes.func,
  showRemainingPercentage: PropTypes.bool,
  showRemainingPercentageFunc: PropTypes.func,
  subDesc: PropTypes.any,
  subTitle: PropTypes.any,
  viewEndowedGrantPlanPdf: PropTypes.func,
  selectSuccessionPlan: PropTypes.func
};

export const mapDispatchToProps = dispatch => ({
  saveOptionData: val => dispatch(saveOptionData(val)),
  removeValues: val => dispatch(removeValues(val)),
  showRemainingPercentageFunc: val => dispatch(showRemainingPercentage(val)),
  selectSuccessionPlan: val => dispatch(selectSuccessionPlan(val))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LegacyAccordions);
